<form [formGroup]="accountPhoneValidationForm">
  @if ((session$ | async) === 'invalid') {
    <div class="alert alert-warning w-100 text-center" role="alert">
      {{ 'MY_ACCOUNT_LOGIN.SESSION_LOGGED_OUT' | translate }}
    </div>
  }
  <div class="row">
    <div class="col-12">
      <div>
        <div class="md-form mt-3 mb-4">
          <label for="phone">{{ 'MY_ACCOUNT_LOGIN.PHONE_NUMBER' | translate }}</label>
          <input type="text" id="phone" class="form-control" mdbInput required formControlName="phoneNumber"
            (keypress)="onlyNumberKey($event)">
          @if (accountPhoneValidationForm.controls.phoneNumber.invalid && (accountPhoneValidationForm.controls.phoneNumber.dirty || accountPhoneValidationForm.controls.phoneNumber.touched)) {
            <mdb-error
              >
              @if (accountPhoneValidationForm.controls.phoneNumber.errors.required) {
                <span role="alert"
                >{{ 'MY_ACCOUNT_LOGIN.ERROR_PHONE_REQ' | translate }}</span>
              }
              @if (accountPhoneValidationForm.controls.phoneNumber.errors.pattern) {
                <span role="alert"
                >{{ 'MY_ACCOUNT_LOGIN.ERROR_PHONE_INVAILD' | translate }}</span>
              }
            </mdb-error>
          }
        </div>
      </div>
    </div>
    <div class="col-12">
      <div>
        <div class="md-form mt-3 mb-3">
          <label for="lnametext">{{ 'MY_ACCOUNT_LOGIN.LAST_NAME' | translate }}</label>
          <input type="text" id="lnametext" class="form-control" mdbInput required formControlName="lastName" maxlength="150">
          @if (accountPhoneValidationForm.controls.lastName.invalid && (accountPhoneValidationForm.controls.lastName.dirty || accountPhoneValidationForm.controls.lastName.touched)) {
            <mdb-error role="alert"
              >
              {{ 'MY_ACCOUNT_LOGIN.ERROR_NAME_REQ' | translate }}
            </mdb-error>
          }
        </div>
      </div>
    </div>
    <div class="pb-4 pt-4 w-100 text-center">

      <button role="button" id="sendVerificationCodeButton" mdbBtn class="btn primary-btn waves-light" mdbWavesEffect type="submit"
        [disabled]="!accountPhoneValidationForm.valid || (inlineLoader$ | async) === true"
        (click)="verifyAccountPhone()">
        @if ((inlineLoader$ | async) === null || (inlineLoader$ | async) === false) {
          <span>
            {{ 'MY_ACCOUNT_LOGIN.SEND_CODE' | translate }}
          </span>
        }
        @if ((inlineLoader$ | async) === true) {
          <span>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ 'MY_ACCOUNT_LOGIN.SEND_CODE' | translate }}
          </span>
        }
      </button>

    </div>

    <div class="w-100 text-center pt-3">
      <div class="w-100 text-center pt-4">
        {{'MY_ACCOUNT_LOGIN.OTP' | translate:{ website:website } }}
        @if (useLegalFolder) {
          <a id="privacyPolicyLinkLegal" tabindex="0" role="link" target="_blank" [attr.aria-label]="('MY_ACCOUNT_LOGIN.PRIVACY_POLICY' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [routerLink]="['/legal/privacy-policy']" [queryParams]="{lang: thisLang}">{{ 'MY_ACCOUNT_LOGIN.PRIVACY_POLICY' | translate }}</a>
        }
        @if (!useLegalFolder) {
          <a id="privacyPolicyLink" tabindex="0" role="link" target="_blank" [attr.aria-label]="('MY_ACCOUNT_LOGIN.PRIVACY_POLICY' | translate) + ' ' + ('FOOTER.OPEN_NEW_TAB' | translate)" [routerLink]="['/privacy-policy']" [queryParams]="{lang: thisLang}">{{ 'MY_ACCOUNT_LOGIN.PRIVACY_POLICY' | translate }}</a>
          }.
        </div>
      </div>
    </div>
  </form>
